<script>
  import QuestionItem from './Item.svelte';

  export let items;
</script>

<div class="questions">
  <ul class="questions__list">
    {#each items as item (item.id)}
      <QuestionItem {item} />
    {/each}
  </ul>
</div>

<style lang="scss">
  .questions {
    &__list {
      margin-top: 5rem;
      margin-bottom: 5rem;
    }
  }
</style>
